var _defs, _rect, _rect2, _text, _text2, _circle, _circle2, _rect3, _text3, _text4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoverFullstackService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 760,
    viewBox: "0 0 1200 760",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Full stack service platform",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0f172a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1f2937"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f97316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fdba74"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 760,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 110,
    width: 1020,
    height: 540,
    rx: 30,
    fill: "#0b1220",
    stroke: "#f97316",
    strokeOpacity: 0.42
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 210,
    fill: "#f8fafc",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 44,
    fontWeight: 800
  }, "FULL-STACK SERVICE APP")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 250,
    fill: "#cbd5e1",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 24
  }, "Booking, reviews, learning, user dashboard")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 420,
    r: 95,
    fill: "url(#ac)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 420,
    r: 45,
    fill: "#111827"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 330,
    width: 640,
    height: 210,
    rx: 16,
    fill: "#111827",
    stroke: "#475569"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 430,
    y: 390,
    fill: "#f8fafc",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700
  }, "React  Node.js  Express  MongoDB")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 430,
    y: 436,
    fill: "#cbd5e1",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 20
  }, "Firebase  JWT  Tailwind  Vercel")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverFullstackService);
export default __webpack_public_path__ + "static/media/cover-fullstack-service.90b4639261dc881478ce04c1ef4bcf24.svg";
export { ForwardRef as ReactComponent };